/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-10-6 14:33:51
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Card, TextStyle, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import {
  ComposeMajor,
  RecentSearchesMajor,
  ThemeStoreMajor,
  TransferInMajor
} from '@shopify/polaris-icons';
import { routes } from 'src/routes';
import { getShop } from 'src/helpers';

type MenuType = {
  title: string,
  content: string,
  src: string,
  href?: string,
  action?: (event: Event) => void,
  actionLabel?: string
};

type State = {
  hover: Array<boolean>
};

type Props = WithI18nProps;
class menuDashboardAppEngagement extends Component<Props, State> {
  // Event mouse for menu items
  state = {
    hover: [false, false, false, false]
  };

  // Event mouse enter for menu item
  onMouseEnter = menuIndex => {
    this.setState(({ hover }) => {
      hover[menuIndex] = true;
      return { hover };
    });
  };

  // Event mouse leave for menu item
  onMouseLeave = menuIndex => {
    this.setState(({ hover }) => {
      hover[menuIndex] = false;
      return { hover };
    });
  };

  render() {
    const { host, i18n } = this.props;
    const shop = getShop();
    const menus: Array<Array<MenuType>> = [
      [
        {
          title: i18n.translate('AdminHTML.Dashboard.Common.editFilterTree'),
          content: i18n.translate(
            'AdminHTML.Dashboard.Common.editYourFilterTreesNamesCollectionsAndFilterOptions'
          ),
          src: ComposeMajor,
          href: `${routes.filterTree.list()}?shop=${shop}&host=${host}`,
          actionLabel: 'Edit Filter Tree'
        },
        {
          title: i18n.translate('AdminHTML.Dashboard.MenuDashboardAppEngagement.menu2_Title'),
          content: i18n.translate('AdminHTML.Dashboard.MenuDashboardAppEngagement.menu2_Content'),
          src: ThemeStoreMajor,
          href: `${routes.productRanking.view()}?shop=${shop}&host=${host}`,
          actionLabel: 'Manage Product Ranking'
        }
      ],
      [
        {
          title: i18n.translate('AdminHTML.Dashboard.Common.manageInstantSearch'),
          content: i18n.translate(
            'AdminHTML.Dashboard.Common.manageAllInstantSearchDisplaySettings'
          ),
          src: RecentSearchesMajor,
          href: `${routes.instantSearchDisplay.view()}?shop=${shop}&host=${host}`,
          actionLabel: 'Manage Instant search'
        },
        {
          title: i18n.translate('AdminHTML.Dashboard.MenuDashboard1.menu4_Title'),
          content: i18n.translate('AdminHTML.Dashboard.MenuDashboard1.menu4_Content'),
          src: TransferInMajor,
          href: `${routes.merchandising.view()}?shop=${shop}&host=${host}`,
          actionLabel: 'Merchandising'
        }
      ]
    ];

    return (
      <div className="BC-Menu__Dashboard">
        <Card title={i18n.translate('AdminHTML.Dashboard.Common.menu')}>
          <Card.Section>
            <Layout>
              {menus.map((menu, menuIndex) => (
                <Layout.Section secondary key={'menu-' + menuIndex}>
                  {menu.map((subMenu, subMenuIndex) => {
                    // Calculate menu index
                    const index = menuIndex * 2 + subMenuIndex;

                    return (
                      <Link
                        className="BC-Link__Dashboard"
                        key={'subMenu-' + subMenuIndex}
                        to={subMenu.href}>
                        <div
                          className="menuBox"
                          onMouseEnter={this.onMouseEnter.bind(this, index)}
                          onMouseLeave={this.onMouseLeave.bind(this, index)}>
                          <div
                            className={
                              this.state.hover[index] ? 'Polaris-Card-Hover' : 'Polaris-Card'
                            }>
                            <div className="Polaris-Card__Section">
                              <div
                                className={
                                  this.state.hover[index] ? 'menuIconImg hover' : 'menuIconImg'
                                }>
                                <Icon source={subMenu.src} color="base" />
                              </div>
                              <div className="menuContent">
                                <TextStyle variation="strong">{subMenu.title}</TextStyle>
                                <TextStyle variation="subdued">{subMenu.content}</TextStyle>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </Layout.Section>
              ))}
            </Layout>
          </Card.Section>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  host: _.get(state.oauth, 'host', '')
});

export default connect(mapStateToProps)(withI18n()(menuDashboardAppEngagement));
